import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    options: [],
    filters: {
      period: [2017,2018]
    },
    min: 2017,
    max: 2018,
    reports: [],
    host:
      process.env.NODE_ENV === "production"
        ? "https://admin-crimenesdeodio.letraese.org.mx/" //"https://letraese.datacivica.org/"
        : "http://localhost:1337/",
    filteredReports: [],
    filteredStates: [],
    selection: undefined,
    identityTypes: [
      {
        slug: "mujertrans",
        title: "Mujer trans"
      },
      {
        slug: "lesbiana",
        title: "Lesbiana/Mujer Homosexual"
      },
      {
        slug: "homosexual",
        title: "Gay/Homosexual"
      }
    ],
    chartSelection: "sexualIdentity",
    chartColors: [
      "#b02020",
      "#3e3082",
      "#d38d00",
      "#1d91c0",
      "#35871b",
      "#225ea8"
    ]
  },
  mutations: {
    setOptions(state, value) {
      state.options = value;
    },
    resetFilters(state) {
      state.filters = {
        period: [state.min,state.max],
        state: "Todas",
        sexualIdentity: "Todas",
        characteristic: "Todas",
        ageGroup: "Todas",
        occupation: "Todas",
        whereWasFound: "Todas",
        weapon: "Todas",
        wasOffenderFound: "Todas",
        bodyState: "Todas",
        sexualViolence: "Todas",
        tortureViolence: "Todas"
      }
    },
    setStateFilter(state, value) {
      state.filters.state = value;
    },
    setSexualIdentityFilter(state, value) {
      state.filters.sexualIdentity = value;
    },
    setAgeGroupFilter(state, value) {
      state.filters.ageGroup = value;
    },
    setCharacteristicFilter(state, value) {
      state.filters.characteristic = value;
    },
    setPeriodFilter(state, value) {
      state.filters.period = value;
    },
    setOccupationFilter(state, value) {
      state.filters.occupation = value;
    },
    setWhereWasFoundFilter(state, value) {
      state.filters.whereWasFound = value;
    },
    setWeaponFilter(state, value) {
      state.filters.weapon = value;
    },
    setWasOffenderFoundFilter(state, value) {
      state.filters.wasOffenderFound = value;
    },
    setBodyStateFilter(state, value) {
      state.filters.bodyState = value;
    },
    setSexualViolenceFilter(state, value) {
      state.filters.sexualViolence = value;
    },
    setTortureViolenceFilter(state, value) {
      state.filters.tortureViolence = value;
    },
    setReports(state, value) {
      state.reports = value;
      state.min = +_.minBy(value, "year")["year"];
      state.max = +_.maxBy(value, "year")["year"];
      state.filters.period = [state.min,state.max];
    },
    setFilteredReports(state, value) {
      state.filteredReports = value;
    },
    setFilteredStates(state, value) {
      state.filteredStates = value;
    },
    setSelection(state, value) {
      state.selection = value;
    }
  },
  getters: {
    selected: state => {
      return state.selection;
    }
  },
  actions: {}
});
